import {
  SET_TIER_NAME,
  SET_TIER_NUMBER,
  SET_ITEM_COUNT,
  SET_OPTED_IN,
  SET_IS_AVAILABLE,
  SET_ENABLE_COMPLIANCE_VARIANT
} from "./constants";

export const getLoyaltyStatus = state => state.loyalty;

const initialState = {
  itemCount: null,
  optedIn: false,
  isAvailable: false,
  tierName: "",
  tierNumber: 0,
  enableComplianceVariant: false
};

export const reduce = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_OPTED_IN: {
      return {
        ...state,
        optedIn: payload.optedIn
      };
    }
    case SET_IS_AVAILABLE: {
      return {
        ...state,
        isAvailable: payload.isAvailable
      };
    }
    case SET_TIER_NAME: {
      return {
        ...state,
        tierName: payload.tierName
      };
    }
    case SET_TIER_NUMBER: {
      return {
        ...state,
        tierNumber: payload.tierNumber
      };
    }
    case SET_ITEM_COUNT: {
      return {
        ...state,
        itemCount: payload.itemCount
      };
    }
    case SET_ENABLE_COMPLIANCE_VARIANT: {
      return {
        ...state,
        enableComplianceVariant: payload.enableComplianceVariant
      };
    }
    default:
      return state;
  }
};
